import {
    MARKETPLACE_ERROR_ACTION_TYPE,
    MARKETPLACE_FETCH_ACTION_TYPE,
    MARKETPLACE_FETCH_SUCCESS_ACTION_TYPE,
    MARKETPLACE_RESET_ACTION_TYPE,
    MarketplaceAction
} from 'actions/marketplace/MarketplaceActionsTypes';
import { MarketplaceState, MarketplaceStatus } from 'reducers/marketplace/MarketplaceState';
import { Reducer } from 'redux';
import { emptyMarketplace } from 'types/Marketplace';

const initialState: MarketplaceState = {
    data: emptyMarketplace,
    status: MarketplaceStatus.Initial,
    loading: true
};

export const marketplaceReducer: Reducer<MarketplaceState, MarketplaceAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case MARKETPLACE_RESET_ACTION_TYPE:
            return {
                ...initialState
            };
        case MARKETPLACE_ERROR_ACTION_TYPE:
            return {
                ...state,
                loading: false,
                status: MarketplaceStatus.Error
            };
        case MARKETPLACE_FETCH_ACTION_TYPE:
            return {
                ...state,
                loading: true,
                status: MarketplaceStatus.Fetching
            };
        case MARKETPLACE_FETCH_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                loading: false,
                status: MarketplaceStatus.FetchSuccess,
                data: action.payload.marketplace
            };
        default:
            return state;
    }
};
